import React from "react";
import { ReactSVG } from "react-svg";
import SVG from "react-inlinesvg";

function SvgIcon({ src, className, ...rest }) {
  return <SVG src={src || ""} className={className} {...rest} />;
}

export default SvgIcon;
